module.exports = __webpack_public_path__ + "img/lr1-mc-y1.b9d1820e.gif";